import { envConfig } from '../../../utils/enviroment';
import { MedicalCare } from '../types';

export function getEnabledMedicalCareList(medicalCareList: MedicalCare[]): MedicalCare | null {
  const medicalCare = medicalCareList?.find(medicalCare =>
    envConfig.REACT_APP_CARE_PLUS_CONSULT_KIND?.includes(medicalCare.id)
  );
  if (!medicalCare) return null;
  return medicalCare;
}
